import { Component, OnInit } from '@angular/core';
import { Cookie } from 'ng2-cookies';
import { AppService } from './../../services/app.service';
import { UserService } from '../../shared/services/user.service';
import { User } from '../../models/user.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TeacherDashService } from '../../pages/teacher-dash/services/teacher-dash.service';
import { AuthService } from '../../shared/services/auth.service';
import { TokenStorageService } from '../../shared/services/token-storage.service';
import {ToastNotificationService} from '../../shared/services/toast-notify.service';
import { environment } from '../../../environments/environment'
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { StaffService } from 'src/app/pages/staff/services/staff.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { Session } from 'src/app/models/session.model';
import { Feature } from 'src/app/models/feature.model';

@Component({
  selector: 'app-sidebar-teacher',
  templateUrl: './sidebar-teacher.component.html',
  styleUrls: ['./sidebar-teacher.component.scss']
})
export class SidebarTeacherComponent implements OnInit {

  userFullName: string;
  userRole: string;
  lastLoggedIn: string;
  dateTimeFormat: string;
  userProfile: User;
  session: Session;
  featureData: Feature[] = [];
  featureJson: { [key: string]: boolean} = {}; //this.featureJson = {"BRANCH":true}


  selectedFiles: FileList;
  fileToUpload: any;
  profilePicUrl: any;
  currentFile?: File;

  salesPipilineMenu: boolean;
  settingMenu: boolean;
  masterMenu: boolean;
  testMenu: boolean;
  notificationMenu: boolean;
  studentMenu: boolean;
  reportMenu: boolean;
  teacherMenu: boolean;

  constructor(private appService: AppService,
              private userService: UserService,
              private teacherDashService: TeacherDashService,
              private toastNotifyService: ToastNotificationService, 
              private tokenStorageService: TokenStorageService,
            private spinnerService: SpinnerService,public subscriptionService: SubscriptionService,
                          public staffService: StaffService,private configService: ConfigService,) { }


  ngOnInit() {
    console.log('***ngOnInit: sidebar-admin');
    // Clear the cookie & local
    //this.deleteSpecificCookies();
    this.salesPipilineMenu = false;
    this.settingMenu = false;
    this.masterMenu = false;
    this.testMenu = false;
    this.notificationMenu = false;
    this.studentMenu = false;
    this.reportMenu = false;
    this.teacherMenu = false;
    this.dateTimeFormat = environment.dtFormatDefault
    
    this.getUserData();   
    this.getActiveSession();
    //this.getSubscriptionFeatures(); 
    this.getSchoolNUserSubscription();
  }

  getUserData(){
    console.log('>>>>>getUserData- sidebar-admin>>>>> ')
    this.teacherDashService.getUserData().subscribe({
      next: (response: any) => {
        console.log(">>>getUserData from service:sidebar parent- "+JSON.stringify(response));
        if(response.status == environment.SUCCESS){
          this.userProfile =  response.data;
        }else{
          // Get from cookie beacuse it happens for first time
          const userData: User = {
            userName: this.tokenStorageService.getUser(),userRole: this.tokenStorageService.getUserRole(),
            clientName: this.tokenStorageService.getTenantName(), branchCode: this.tokenStorageService.getBranchCode(), ownerName: this.tokenStorageService.getOwnerName()}
          
          this.userProfile = userData;
          //this.toastNotifyService.showErrorWithTimeout(response.message, "Notification", 7000);
        }           
      },
      error: (e) => {
        console.error(e);          
      }
    });
  }

  toggleFlag(category: string, value: boolean){
    console.log('category: '+category+': value: '+value);
    var toggle = value ? false : true;
    //return toggle;
    if('sales_pipeline' == category){
      this.salesPipilineMenu = toggle;
    }else if('setting' == category){
      console.log('--------------Setting Menu------------')
      this.settingMenu = toggle;
    }else if('master' == category){
      console.log('--------------Master Menu------------')
      this.masterMenu = toggle;
    }else if('test_exam' == category){
      this.testMenu = toggle;
    }else if('notification' == category){
      this.notificationMenu = toggle;
    }else if('student' == category){
      this.studentMenu = toggle;
    }else if('report' == category){
      this.reportMenu = toggle;
    }else if('teacher' == category){
      this.teacherMenu = toggle;
    }
  }
  getActiveSession(){
    console.log('>>>>>getActiveSession- sidebar-admin>>>>> ')
    this.userService.getActiveSession().subscribe({
      next: (response: any) => {
        console.log(">>>getActiveSession from service:sidebar aadmin- "+JSON.stringify(response));
        if(response.status == environment.SUCCESS){
          this.session =  response.data;    
        }else if(response.status == environment.FAILURE){    
          console.log('!!! Failure response in getActiveSession....')      
          //this.toastNotifyService.showErrorWithTimeout(response.message, "Notification", 7000);
        }           
      },
      error: (e) => {
        console.error('!!! Error in getBranchDetail: ',e);          
      }
    });
  }

  /*getSubscriptionFeatures(){
    this.subscriptionService.getSchoolSubscription().subscribe({
      next: (value: any) => {
        this.featureData = value;
        console.log('>>>>>>>>>>this.subscription  features:', JSON.stringify(this.featureData));
        this.buildFeatureJson(this.featureData);
      },
      error: (err) => console.error('An error occurred:', err),
      complete: () => console.log('Observable completed')
    })
  }*/
  getSchoolNUserSubscription(){
    let tenant = this.configService.getConfiguration().clientName;
    this.subscriptionService.getSchoolNUserSubscription(tenant).subscribe({
      next: (res) => {
        this.featureData = res.data;
        console.log('>>>>>>>>>>getSchoolNUserSubscription  features:', JSON.stringify(this.featureData));
        this.buildFeatureJson(this.featureData);
      },
      error: (err) => console.error('An error occurred:', err),
      complete: () => console.log('Observable completed')
    })
  }
  buildFeatureJson(FeatureArray: Feature[]){
    FeatureArray.forEach((feature: any) => {
      this.featureJson[feature.name] = feature.enabled;
    });
    console.log('this.featureJson>>>>>>>>', JSON.stringify(this.featureJson))
  }
  isSubscribed(feature: string){// Not used now since it was called repetedly on any menu click
    /*const value = this.subscription.find((item: any) => item.name === feature)?.enabled;
    console.log('>>>>> is this feature subscribed:'+feature+' :',value); // "true/false"
    return value;*/
    const matchedItem = this.featureData.find((item : any) => item.name === feature);
    if (matchedItem) {
      return matchedItem.enabled;
    }else{
      return false;
    }
  }

  deleteSpecificCookies(){
    Cookie.delete("org_id");
    Cookie.delete("org_name");
    Cookie.delete("dtFormat");
    console.log('***specific cookies deleted***');
  }

  /***************************************Profile Pic***************************************/
  selectProfilePic(event: any,staffCode: string): void {
    this.selectedFiles = event.target.files;
    this.fileToUpload = event.target.files.item(0);
    this.uploadProfilePicture(staffCode); // save in database & returns res.code= pic url    
  }
  uploadProfilePicture(staffCode: string){
    console.log('-------uploadProfilePicture for: '+staffCode);
    this.spinnerService.showSpinner();
    const file: File | null = this.selectedFiles.item(0);
    if (file) {
      this.currentFile = file;
      console.log('filenameeee>>>>>>>>>',this.currentFile.name)
      let tenant = this.configService.getConfiguration().clientName;
      this.staffService.uploadProfilePicture(this.currentFile,staffCode, tenant).subscribe(
      res => {
          this.currentFile = undefined;
          //this.resetFileUploader();   
          if(environment.SUCCESS == res.status){
            this.toastNotifyService.showSuccess(res.message, "Notification");
          }else if(environment.FAILURE == res.status){
            this.toastNotifyService.showErrorWithTimeout(res.message, "Notification", 10000);
          }   
          this.spinnerService.hideSpinner();      
        },
        error => {
          console.log('***Error in uploadProfilePicture...'+error);
          this.spinnerService.hideSpinner();
          this.currentFile = undefined;
          //this.resetFileUploader();                   
        },
      );
    }
    this.spinnerService.hideSpinner();
  }

}
